import { Modal, Select, theme } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import type { RiskAssessmentOption } from '../types'

type Props = {
  isModalVisible: boolean
  setIsModalVisible: (visible: boolean) => void
  pendingRiskAssessmentIds: string[]
  setPendingRiskAssessmentIds: (ids: string[]) => void
  riskAssessmentOptions: RiskAssessmentOption[]
  onConfirm: () => void
  onCancel: () => void
}

const LinkRiskAssessmentsModal = ({
  isModalVisible,
  setIsModalVisible,
  pendingRiskAssessmentIds,
  setPendingRiskAssessmentIds,
  riskAssessmentOptions,
  onConfirm,
  onCancel
}: Props) => {
  return (
    <Modal
      noPadding
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      onConfirm={onConfirm}
      onCancel={onCancel}
      localisation={{
        title: 'Link Risk Assessments',
        confirmText: 'Save',
        cancelText: 'Cancel'
      }}
    >
      <Select<string[], { label: string; value: string; reviewedOn?: string }>
        mode="multiple"
        style={{ width: '100%' }}
        placeholder="Select risk assessments"
        value={pendingRiskAssessmentIds}
        onChange={(value) => setPendingRiskAssessmentIds(value)}
        options={riskAssessmentOptions.map((option) => ({
          value: option.id,
          label: option.name,
          reviewedOn: option.reviewedOn
        }))}
        optionRender={(option) => {
          const data = option.data as {
            label: string
            reviewedOn?: string
          }

          return (
            <OptionContainer>
              <OptionContent>
                <OptionTitle>{data.label}</OptionTitle>
                <OptionDescription>
                  {'Reviewed '}
                  {data.reviewedOn
                    ? dayjs(data.reviewedOn).format('DD/MM/YYYY - HH:mm')
                    : '--'}
                </OptionDescription>
              </OptionContent>
            </OptionContainer>
          )
        }}
      />
    </Modal>
  )
}

const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 3px 0;
  gap: 8px;
`

const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

const OptionTitle = styled(Text)`
  font-weight: 500;
  color: ${theme.color.neutral.color2};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const OptionDescription = styled(Text)`
  font-size: 12px;
  color: ${theme.color.neutral.color3};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export default LinkRiskAssessmentsModal
